import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { RotatingLines } from 'react-loader-spinner';

import WithLabel, { LABEL_STYLES } from '../../components/with-label/WithLabel';
import WithError from '../../components/with-error/WithError';
import CommonTextarea from '../../components/common-textarea/CommonTextarea';
import CommonButton, { BUTTON_STYLES } from '../../components/common-button/CommonButton';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import { resetSession } from '../../redux/ai-playground/aiPlaygroundActions';
import AssistantFields from './assistant-fields/AssistantFields';

import scss from '../AiPlayground.module.scss';

function PlaygroundForm({ onSubmit }) {
  const { t } = useTranslation('scout');
  const dispatch = useDispatch();

  const form = useForm();

  const isFormLoading = useSelector((state) => state.aiPlayground.isFormLoading);
  const isResetting = useSelector((state) => state.aiPlayground.isResetting);
  const isGenerating = useSelector((state) => state.aiPlayground.isGenerating);
  const threadId = useSelector((state) => state.aiPlayground.threadId);

  const disableFields = isFormLoading || isResetting || isGenerating;

  const handleResetSession = async () => {
    await dispatch(resetSession());
    form.restart();
  };

  return (
    <div className={scss.formWrapper}>
      <div className={scss.formRow}>
        <AssistantFields />

        <Field name='message'>
          {({ meta, input }) => (
            <WithLabel variant={LABEL_STYLES.ROW} label={t('chat')} isBold extraClassName={scss.textAreaField}>
              <WithError isShowError={meta.submitFailed && meta.error} errorText={t(meta.error)} isAbsolute>
                <CommonTextarea
                  name={input.name}
                  value={input.value}
                  onChange={input.onChange}
                  onFocus={input.onFocus}
                  onBlur={input.onBlur}
                  disabled={disableFields}
                  isError={meta.submitFailed && meta.error}
                  rows={4}
                  onEnter={onSubmit}
                  enableVoiceInput
                />
              </WithError>
            </WithLabel>
          )}
        </Field>

        <div className={scss.actions}>
          <CommonButton styleColor={BUTTON_STYLES.PRIMARY} type='submit' onClick={onSubmit} disabled={disableFields}>
            {isGenerating ? (
              <RotatingLines strokeColor='#fdbf47' strokeWidth='5' animationDuration='0.75' width={16} visible={true} />
            ) : (
              t('generate')
            )}
          </CommonButton>

          <CommonButton
            styleColor={BUTTON_STYLES.SECONDARY}
            onClick={handleResetSession}
            disabled={!threadId || disableFields}>
            {t('resetSession')}
            <Icon icon={ICONS.Reset} className={clsx(isResetting && scss.spinAnimation)} />
          </CommonButton>
        </div>
      </div>
    </div>
  );
}

export default PlaygroundForm;
